import axios from "axios";

const RSVP_SETTINGS_PATH = "/api/event/rsvp-settings";

export function getEventRsvpSettings({ eventId, definitionId, includeWhatsAppTemplates = false, signal } = {}) {
  return axios.get(RSVP_SETTINGS_PATH, {
    params: { event_id: Number(eventId), ...(definitionId ? { definition_id: definitionId } : {}), ...(includeWhatsAppTemplates ? { include_whatsapp_templates: 1 } : {}) },
    signal,
  });
}

export function putEventRsvpSettings(payload) {
  return axios.put(RSVP_SETTINGS_PATH, payload);
}

export function getEventRsvpResponses({ eventId, definitionId, search, choice, responseDate, responseStart, responseEnd, source, timeZone, page = 1, pageSize = 50, signal } = {}) {
  return axios.get("/api/event/rsvp-responses", {
    params: { event_id: Number(eventId), definition_id: definitionId, search, choice, response_date: responseDate, response_start: responseStart, response_end: responseEnd, source, time_zone: timeZone, page, page_size: pageSize },
    signal,
  });
}

export function getParticipantRsvpHistory({ eventId, userId, definitionId, beforeId, signal } = {}) {
  return axios.get(`/api/event/rsvp-responses/${Number(userId)}`, {
    params: { event_id: Number(eventId), definition_id: definitionId, before_id: beforeId }, signal,
  });
}

export function correctParticipantRsvp({ eventId, userId, definitionId, choice, optionId, expectedRevision, requestKey }) {
  return axios.post(`/api/event/rsvp-responses/${Number(userId)}`, {
    event_id: Number(eventId), definition_id: definitionId, choice, option_id: optionId,
    expected_revision: expectedRevision, request_key: requestKey,
  });
}

export function resetEventRsvpResponses({ eventId, definitionId, expectedCount, requestKey }) {
  return axios.post("/api/event/rsvp-responses/reset", {
    event_id: Number(eventId), definition_id: definitionId,
    expected_count: expectedCount, request_key: requestKey,
  });
}
